<template>
  <div>
    <v-data-table :headers="headers" :items="payments" :loading="loading">
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>

      <template slot="no-data">
        <v-alert :value="true" color="warning" icon="warning"
          >Não há pagamentos para este contrato</v-alert
        >
      </template>

      <template slot="item" slot-scope="props">
        <tr>
          <td>
            <v-icon
              @click="selectPayment(props.item)"
              v-if="selectedPayments.includes(props.item.id)"
              >check_box</v-icon
            >
            <v-icon v-else @click="selectPayment(props.item)"
              >check_box_outline_blank</v-icon
            >
          </td>
          <td>{{ props.item.date | moment("L") }}</td>
          <td>{{ props.item.processingDate | moment("L") }}</td>
          <td>{{ collections.objectTypes[props.item.object].text }}</td>
          <td style="text-align: right;">{{ props.item.amount | money }}</td>
          <td>
            <v-tooltip
              max-width="350"
              v-if="props.item.notes && props.item.notes.length > 0"
              left
            >
              <template v-slot:activator="{ on }">
                <v-icon color="grey lighten-1" v-on="on">info</v-icon>
              </template>
              <span>{{ props.item.notes }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn
              :disabled="props.item.processed"
              @click="confirmDelete(props.item)"
              small
              text
              icon
            >
              <v-icon v-if="props.item.processed">check_box</v-icon>
              <v-icon v-else>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog :value="form.visible" persistent width="50%">
      <v-card>
        <v-card-title class="headline">
          Pagamento do Contrato
          <v-spacer></v-spacer>
          <span class="subheading pr-4"
            >Saldo : {{ (pending - form.payment.amount) | money }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-layout mx-4 wrap>
            <v-flex md4>
              <v-select
                :items="collections.objectTypes"
                item-value="id"
                item-text="text"
                v-model="form.payment.object"
                label="Objeto"
                id="paymentObjectType"
                name="paymentObjectType"
              ></v-select>
            </v-flex>
            <v-flex md4>
              <MoneyInput
                name="paymentAmount"
                label="Valor"
                id="paymentAmount"
                v-model="form.payment.amount"
              ></MoneyInput>
            </v-flex>
            <v-flex md4>
              <v-select
                :items="collections.paymentTypes"
                item-value="id"
                item-text="text"
                v-model="form.payment.type"
                label="Tipo"
                id="paymentPaymentType"
                name="paymentPaymentType"
              ></v-select>
            </v-flex>
            <v-flex pt-3 md12 v-if="form.payment.type == 3">
              <v-card>
                <v-card-title class="subheading">Dados do Cartão</v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex md3>
                      <v-text-field
                        label="Últimos 4 dígitos"
                        id="paymentCreditCardLast4Digits"
                        name="paymentCreditCardLast4Digits"
                        v-model="form.payment.creditCard.last4Digits"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md9>
                      <v-text-field
                        label="Bandeira"
                        id="paymentCreditCardBrand"
                        name="paymentCreditCardBrand"
                        v-model="form.payment.creditCard.brand"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex pt-3 md12 v-if="form.payment.type == 2">
              <v-card>
                <v-card-title class="subheading">Dados do Cheque</v-card-title>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex md3>
                      <v-text-field
                        label="Cheque núm."
                        id="paymentCheckNumber"
                        name="paymentCheckNumber"
                        v-model="form.payment.check.number"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md9>
                      <v-text-field
                        name="paymentCheckBank"
                        label="Banco"
                        id="paymentCheckBank"
                        v-model="form.payment.check.bank"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md3>
                      <v-text-field
                        name="paymentCheckBranch"
                        label="Agência"
                        id="paymentCheckBranch"
                        v-model="form.payment.check.branch"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md9>
                      <v-text-field
                        name="paymentCheckAccount"
                        label="Conta Corrente"
                        id="paymentCheckAccount"
                        v-model="form.payment.check.account"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex pt-3 md12>
              <v-textarea
                name="notes"
                label="Observações"
                id="notes"
                v-model="form.payment.notes"
              ></v-textarea>
            </v-flex>
            <v-flex md12 v-if="canSplit">
              <v-checkbox
                label="Parcelar?"
                v-model="form.split"
                value="true"
              ></v-checkbox>
            </v-flex>
            <v-layout v-if="form.split && canSplit">
              <v-flex md3>
                <v-text-field
                  name="splitInto"
                  label="Num. Parcelas"
                  id="splitInto"
                  type="number"
                  v-model="form.splitInto"
                ></v-text-field>
              </v-flex>
              <v-flex md3>
                <v-text-field
                  name="splitRepeatEvery"
                  label="Intervalo (dias)"
                  id="splitRepeatEvery"
                  v-model="form.splitRepeatIntervalInDays"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <DatePicker
                  name="splitStartsOn"
                  label="Primeira para"
                  id="splitStartsOn"
                  v-model="form.splitStartsOn"
                ></DatePicker>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="form.visible = false" text transparent>Close</v-btn>
          <v-btn @click="save" text transparent>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      ref="executingStatusCard"
      progressMessage="Operação em progresso"
      successMessage="Pronto"
      errorMessage="Falha ao executar operação"
    />
    <ConfirmDialog
      id="confirmDeleteDialog"
      ref="confirmDeleteDialog"
      title="Excluir Registro"
      :message="`Deseja realmente excluir este pagamento?`"
      yes-button="Sim"
      no-button="Não"
      @confirm="this.delete"
    />
  </div>
</template>
<script>
import api from "@/api";
import ConfirmDialog from "@/components/Shared/ConfirmDialog";
import MoneyInput from "@/components/Shared/MoneyInput";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
import DatePicker from "@/components/Shared/DatePicker";
export default {
  props: ["contractId", "totalCost"],
  components: {
    ConfirmDialog,
    MoneyInput,
    OperationStatusCard,
    DatePicker
  },
  computed: {
    canSplit() {
      return this.form.payment.type != 2;
    },
    pending() {
      var totalPaid = 0;
      if (this.payments && this.payments.length > 0) {
        totalPaid = this.payments
          .map(p => p.amount)
          .reduce((acc, curr) => acc + curr);
      }
      return this.totalCost - totalPaid;
    }
  },
  data() {
    return {
      collections: {
        objectTypes: [
          { id: 0, text: "Pacote" },
          { id: 1, text: "Opcional" }
        ],
        paymentTypes: [
          { id: 1, text: "Espécie" },
          { id: 2, text: "Cheque" },
          { id: 3, text: "Cartão" },
          { id: 4, text: "Boleto" },
          { id: 5, text: "Transferência" }
        ]
      },
      loading: false,
      headers: [
        {
          text: "",
          value: "id",
          sortable: false,
          width: 30
        },
        {
          text: "Data",
          value: "date",
          sortable: false
        },
        {
          text: "Data Baixa",
          value: "processingDate",
          sortable: false
        },
        {
          text: "Objeto",
          value: "object",
          sortable: false
        },
        {
          text: "Valor",
          value: "amount",
          sortable: false,
          align: "end"
        },
        {
          text: "",
          value: "notes",
          sortable: false,
          width: 30
        },
        {
          text: "",
          value: "id",
          sortable: false,
          width: 30
        }
      ],
      selectedPayments: [],
      payments: [],
      paymentToDelete: null,
      form: {
        visible: false,
        split: false,
        splitInto: 1,
        splitStartsOn: null,
        splitRepeatEvery: 30,
        payment: {
          amount: 0,
          card: {
            last4Digits: "",
            brand: ""
          },
          check: {
            number: "",
            bank: "",
            branch: "",
            account: ""
          },
          object: "",
          type: ""
        }
      }
    };
  },
  methods: {
    showPaymentForm() {
      this.form.payment = {
        amount: 0,
        object: this.collections.objectTypes[0].id,
        type: this.collections.paymentTypes[0].id,
        creditCard: {},
        check: {}
      };
      this.form.visible = true;
      this.form.split = false;
      this.form.splitInto = 1;
      this.form.splitStartsOn = null;
      this.form.splitRepeatIntervalInDays = 30;
    },
    save() {
      if (this.contractId) {
        this.$refs.executingStatusCard.show();

        var payload = {
          payment: this.form.payment,
          splitOptions: null
        };

        if (this.canSplit && this.form.split) {
          var splitInto = Number(this.form.splitInto);
          var isValidSplitAmount =
            splitInto >= 1 && Number.isInteger(splitInto);
          if (!isValidSplitAmount) {
            this.$refs.executingStatusCard.fail([
              "A quantidade de parcelas deve ser de no mínimo 1"
            ]);
            return;
          }

          if (!this.form.splitStartsOn) {
            this.$refs.executingStatusCard.fail([
              "Informe a data da primeira parcela"
            ]);
            return;
          }

          payload.splitOptions = {
            splitInto: splitInto,
            repeatIntervalInDays: this.form.splitRepeatIntervalInDays,
            startsOn: this.form.splitStartsOn
          };
        }

        api
          .request("POST", `/contracts/${this.contractId}/payments`, payload)
          .then(() => {
            this.form.visible = false;
            this.$refs.executingStatusCard.succeed();
            this.loadPayments();
          })
          .catch(error => {
            this.$refs.executingStatusCard.fail(error.response.data);
          });
      }
    },
    confirmDelete(payment) {
      this.paymentToDelete = payment;
      this.$refs.confirmDeleteDialog.show();
    },
    delete() {
      if (this.contractId) {
        this.$refs.executingStatusCard.show();
        api
          .request(
            "DELETE",
            `/contracts/${this.contractId}/payments/${this.paymentToDelete.id}`
          )
          .then(() => {
            this.paymentToDelete = null;
            this.$refs.executingStatusCard.succeed();
            this.loadPayments();
          })
          .catch(error => {
            this.$refs.executingStatusCard.fail(error.response.data);
          });
      }
    },
    loadPayments() {
      if (this.contractId) {
        this.loading = true;
        this.selectedPayments = [];
        api
          .request("GET", `/contracts/${this.contractId}/payments`)
          .then(response => {
            this.payments = response.data.payments;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    selectPayment(payment) {
      if (!this.selectedPayments.includes(payment.id)) {
        var otherPayment =
          this.selectedPayments.length == 0
            ? null
            : this.payments.filter(p => p.id == this.selectedPayments[0])[0];
        if (!otherPayment || otherPayment.object == payment.object) {
          this.selectedPayments.push(payment.id);
        } else {
          alert(
            "Somente pgamentos do mesmo tipo de objeto podem ser selecionados"
          );
        }
      } else {
        this.selectedPayments = this.selectedPayments.filter(
          id => id != payment.id
        );
      }
      this.$emit("selectedPayments", this.selectedPayments);
      this.$emit("selectedPaymentObject", payment.object);
    }
  },
  mounted() {
    this.loadPayments();
  }
};
</script>
